<template>
    <div :class="phoneClass || 'authority-add'">
        <content-header :title="$t('authority.new_group')"></content-header>
        <div class="authority-add-bg">
            <div class="authority-add-section">
                <h1>{{$t('authority.add.group_message')}}</h1>
                <div class="authority-add-state">
                    <div>
                        <p>{{$t('authority.group_name')}}</p>
                        <el-input v-model="groupName" :placeholder="$t('message.enter')"></el-input>
                    </div>
                    <div>
                        <p>{{$t('authority.add.leader_name')}}</p>
                        <el-input v-model="userName" :placeholder="$t('message.enter')"></el-input>
                    </div>
                    <div>
                        <p>{{$t('authority.phone')}}</p>
                        <el-input v-model="phone" :placeholder="$t('message.enter')"></el-input>
                    </div>
                    <div>
                        <p>{{$t('authority.state')}}</p>
                        <el-switch
                                v-model="is_enable"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                :active-value="0"
                                :inactive-value="1">
                        </el-switch>
                    </div>
                </div>
                <div class="authority-add-state">
                    <h5>{{$t('authority.add.account_password')}}</h5>
                    <span></span>
                    <div>
                        <p>{{$t('authority.email')}}</p>
                        <el-input v-model="email" :placeholder="$t('message.enter')"></el-input>
                    </div>
                    <div>
                        <p>{{$t('authority.password')}}</p>
                        <el-input v-model="password" :placeholder="$t('message.enter')"></el-input>
                    </div>
                </div>
                <div class="authority-add-state">
                    <h5>{{$t('authority.authority')}}</h5>
                    <span></span>
                    <template>
                        <el-checkbox-group v-model="checkList" >
                            <el-checkbox v-for="item in authList" :key="item.id"  :value="item.id" :label="item.id">{{item.i18n_name}}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                </div>
            </div>
            <div>
                <el-button type="success" @click="addGroup">{{$t('devicePage.addition')}}</el-button>
                <el-button @click="closeAdd">{{$t('devicePage.close')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import contentHeader from '../../components/content-header'
    import Core from "core/core";
    import {refresh} from "core/winSize"
    import i18n from "../../../src/locales";
    export default {
        data(){
	        return {
		        phoneClass: '',
		        groupName: '',
		        userName: '',
		        phone: '',
		        email: '',
		        password: '',
		        is_enable: '',
		        value1: true,
		        value2: 0,
		        input: '',
		        authList: '',
		        checkList: [],
		        checkShow: true
	        }
        },
        components:{
            contentHeader
        },
	    created() {
		    refresh(this,'phoneClass-authority-add');
		    window.onresize = function(){
			    setTimeout(function(){
				    refresh(this,'phoneClass-authority-add');
			    },10)
		    };
	    },
        mounted(){
          this.getAuthList()
        },
        methods:{
            getAuthList(){
                Core.Api.Auth.authList().then((res)=>{
                    let list = res.auth_list
                    list.forEach((item) => {
                        item['i18n_name'] = i18n.t('auth.' + item.key)
                    })
                    list.splice(2,1)
                    this.authList = list
	                // console.log(this.authList,'权限列表');
                })
            },
            check(){
                if(this.email){
                    let email = this.email
	                let emailReg = Core.Const.EMAIL_REG
	                if( emailReg.test(email) ){
                        if(this.password.length>0){
                            this.checkShow = false
                        } else {
                            this.$message.error('请输入密码');
                        }
                    } else {
                        this.checkShow = true
                        this.$message.error('邮箱格式不正确');
                    }
                } else {
                    this.checkShow = true
                    this.$message.error('请输入邮箱');
                }
            },
            addGroup(){
                if(this.groupName && this.userName && this.phone && this.email && this.password) {

	                // if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))){
		            //     this.$message.error('手机号码有误，请重填');
		            //     return false;
	                // }
                    this.check()
                    if (!this.checkShow) {
                        Core.Api.Group.addGroup(
                            this.groupName,
                            this.userName,
                            this.phone,
                            this.email,
                            this.password,
                            this.is_enable,
                            this.checkList
                        ).then(res => {
                            this.$message.success('添加成功');
                            this.$router.push('/authority')
                        }).catch(err => {
                            console.error(err);
                        });
                    }
                } else {
                    this.$message.error('请将信息填写完整');
                }
            },
            closeAdd(){
                this.$router.push('/authority')
            }
        }
    }
</script>

<style scoped lang="scss">
    .authority-add {
        height: 800px;
        .authority-add-bg {
            margin-top: 30px;
            position: absolute;
            left: 18vw;
            right: 18vw;
            .authority-add-section {

                h1 {
                    font-size: 20px;
                }
                h5 {
                    font-size: 14px;
                    margin-top: 30px;
                }
                .authority-add-state {
                    >span {
                        display: inline-block;
                        width: 100%;
                        height: 1px;
                        background: #EBEDF3;
                    }
                    >div {
                        >p {
                            margin-bottom: 6px;
                            font-size: 14px;
                            color: #7A8799;
                        }
                        display: inline-block;
                        width: 45%;
                        margin-right: 4.5%;
                        margin-top: 20px;
                    }
                }
            }
        }

    }

</style>
<style lang="scss">
.authority-add {

    .authority-add-state {
        input {
            height: 40px;
        }
        .is-checked{
            .el-checkbox__inner{
                background: #0AC47A;
                border: #0AC47A;
            }
            .el-checkbox__label{
                color: #31C27C;
            }
        }
    }
    .authority-add-bg {
        .el-button {
            height: 40px;
            font-size: 15px;
            margin-top: 60px;
            width: 116px;
        }
    }
}
.phoneClass-authority-add {
    .authority-add-bg {
        width: 70%;
        margin: 0 auto;
        .authority-add-section {
            >h1 {
                font-size: 20px;
                margin-top: 15px;
                margin-bottom: 10px;
            }
            .authority-add-state {
                >h5 {
                    margin-top: 16px;
                    font-size: 16px;
                    margin-bottom: 6px;
                }
                >div {
                    margin-bottom: 10px;
                    >p {
                        margin-bottom: 6px;
                    }
                    .el-input__inner {
                        height: 30px;
                    }
                }

                .el-checkbox-group{
                    .el-checkbox {
                        width: 100%;
                    }
                }
            }
        }

        .el-button {
            margin-top: 10px;
        }
    }

}
</style>